import { Checkbox, FormControlLabel } from '@mui/material';
import { useFieldContext } from '.';

type CheckboxFieldProps = {
  label: React.ReactNode;
  disabled?: boolean;
};

export const CheckboxField = (props: CheckboxFieldProps) => {
  const field = useFieldContext<boolean>();
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={field.state.value}
          onChange={(e) => field.handleChange(e.target.checked)}
          disabled={props.disabled}
        />
      }
      label={props.label}
      disabled={props.disabled}
    />
  );
};
